import {makeAutoObservable} from "mobx";
import {api, catchApi} from "../../api";
import {validationStore} from "../ValidationStore";
import {equals} from "../../utils";
import {PmsFormData} from "../../components/page/pms/PmsForm";
import {PrinterDto, PrinterTypeDto} from "../../api/pms";

const emptyObject = {
    name: '',
    displayName: '',
    type: undefined,
}

class PmsCreateStore {
    get type(): PrinterTypeDto | undefined {
        return this._type;
    }

    set type(value: PrinterTypeDto | undefined) {
        this._type = value;
    }
    get name(): string | undefined {
        return this._name;
    }

    set name(value: string | undefined) {
        this._name = value;
    }
    get displayName(): string | undefined {
        return this._displayName;
    }

    set displayName(value: string | undefined) {
        this._displayName = value;
    }

    get creating(): boolean {
        return this._creating;
    }

    set creating(value: boolean) {
        this._creating = value;
    }

    get valid(): boolean {
        return this._valid;
    }

    set valid(value: boolean) {
        this._valid = value;
    }

    get dirty(): boolean {
        const current = this.build()
        return !equals(emptyObject, current)
    }


    private _creating: boolean = false
    private _valid: boolean = false

    private _displayName: string | undefined
    private _name: string | undefined
    private _type: PrinterTypeDto | undefined = PrinterTypeDto.DOCUMENT

    constructor() {
        makeAutoObservable(this)
    }

    get formData(): PmsFormData {
        const {
            displayName,
            name,
            type
        } = this
        return {
            type,
            displayName,
            name
        }
    }

    set formData(data: PmsFormData) {
        const {
            name,
            type,
            displayName
        } = data
        this.name = name
        this.displayName = displayName
        this.type = type
    }

    async create(): Promise<string | void> {
        this.creating = true
        const data = this.build()
        const result = await catchApi(async () => await api.pms.api.createPrinter(data))
        this.creating = false
        return result?.data?.id
    }

    async validate() {
        this.valid = false
        const dto = this.build()
        await validationStore.validate(api.pms.api.validatePrinter, dto)

        this.valid = Boolean(validationStore.valid)
    }

    public reset() {
        this.name = ''
        this.displayName = ''
        this.type = PrinterTypeDto.DOCUMENT
    }


    public build(): PrinterDto {
        const {
            name,
            displayName,
            type
        } = this
        return {
            name: name || '',
            displayName: displayName || '',
            type: type || PrinterTypeDto.DOCUMENT
        }
    }
}

const pmsCreateStore = new PmsCreateStore()

export {
    pmsCreateStore
}
